import * as React from "react";
import { CustomerTypeArrays, CustomerTypeArraysMap, titleLabels } from "../../Resource/Contents";
import { RadioGroup } from "../../../../../../../react-core/Html/RadioGroup";
import { validationMessage } from "../../Resource/Validation";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { CustomerType } from "../../../../../../../Wrap/Constants/Enums/Customer/CustomerType";

interface IClientTypeSelectionProps extends IProcessComponentProps {}

interface IClientTypeSelectionState {}

export class ClientTypeSelection extends ProcessComponent<IClientTypeSelectionProps, IClientTypeSelectionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {
        const options = !this.props.data?.ProductPermissions?.some(permission => permission.ProductPermissionsId == 9)
            ? CustomerTypeArrays.filter(type => type !== CustomerType.Child)
            : CustomerTypeArrays;
        return (
            <>
                <RadioGroup
                    cssWrapper={"mt-40 control-size-430"}
                    label={titleLabels.clientType}                    
                    options={options}
                    getText={(option) => {
                        return CustomerTypeArraysMap[option];
                    }}
                    onChange={(value) => this.props.onChange(value)}
                    required={validationMessage.clientTypeValidation}
                    selected={this.props.data?.CustomerType}
                />
            </>
        );
    }
}
